export default function PollIcon({ className = "", color = "#BB1B2D", size = 22 }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={size}
            height={size}
            fill="none"
            className={className}
            aria-label="Løftebarometeret"
        >
            {/* Option 1 — længste bar */}
            <circle cx="4" cy="6" r="1.4" fill={color} />
            <rect x="7.5" y="4.8" width="13.5" height="2.4" rx="1.2" fill={color} />

            {/* Option 2 — korteste bar */}
            <circle cx="4" cy="12" r="1.4" fill={color} />
            <rect x="7.5" y="10.8" width="8" height="2.4" rx="1.2" fill={color} />

            {/* Option 3 — mellemlang bar */}
            <circle cx="4" cy="18" r="1.4" fill={color} />
            <rect x="7.5" y="16.8" width="11" height="2.4" rx="1.2" fill={color} />
        </svg>
    );
}
